export const NAMESPACE = 'KanBo/userBlockers/'
export const SET_COUNT = NAMESPACE + 'SET_COUNT'

const initialState = {
  count: 0,
}

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case SET_COUNT:
      return {
        ...state,
        count: action.payload.count
      }
    default: return state
  }
}

export function setCount ({ count }) {
  return {
    type: SET_COUNT,
    payload: {
      count
    }
  }
}
